import React from 'react';
import { FormattedMessage } from 'react-intl';

function CreatedByCell(props) {
  const { cell } = props;
  return (
    <div>{cell.value || <FormattedMessage id="common.user.system" />}</div>
  );
}

export default CreatedByCell;
